"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filters = void 0;
var FilterMobile_hbs_1 = __importDefault(require("./FilterMobile.hbs"));
var Select_1 = require("components/Select/Select");
require("./filters.scss");
require("./filter-mobile.scss");
var filters = {
    init: function () {
        Select_1.select.init();
        filters.renderMobileFilterButton();
        filters.customFilterToogle();
        filters.addEventListeners();
        filters.filterSearch();
    },
    get: function (queryString) {
        var searchParams = new URLSearchParams(queryString);
        var searchInput = document.querySelector("[js-filter-search]");
        var valuesArray = [];
        searchParams.forEach(function (val, key) {
            if (key === "q") {
                searchInput.value = val;
            }
            else {
                valuesArray = val.split(",");
                var selectDropDown = document.querySelector("[name=\"".concat(key, "\""));
                if (selectDropDown) {
                    var selectToggle = selectDropDown.querySelector("[js-select-toggle]");
                    var isMultiSelect = false;
                    if (selectToggle !== null) {
                        if (selectToggle.dataset.multiple === "true") {
                            isMultiSelect = true;
                        }
                        var itemsCount_1 = 0;
                        if (selectDropDown) {
                            valuesArray.forEach(function (value) {
                                var optionItem = document.querySelector("[data-select-value=\"".concat(value, "\""));
                                if (optionItem) {
                                    optionItem.classList.add("checked");
                                    itemsCount_1++;
                                }
                            });
                            Select_1.select.setLabels(selectDropDown, itemsCount_1, isMultiSelect);
                        }
                    }
                }
            }
        });
    },
    set: function () {
        var selects = document.querySelectorAll("[js-select]");
        var ranges = document.querySelectorAll("[js-range]");
        var searchInput = document.querySelector("[js-filter-search");
        var urlArray = [];
        var urlParams = new URLSearchParams;
        if (searchInput) {
            if (searchInput.value !== "") {
                urlArray.push({
                    "key": "q",
                    "value": searchInput.value
                });
            }
        }
        selects.forEach(function (select) {
            var optionsArray = [];
            var name = select.getAttribute("name");
            var selectedOptions = select.querySelectorAll("[js-select-item].checked");
            if (selectedOptions.length > 0) {
                selectedOptions.forEach(function (selectedOption) {
                    var item = selectedOption;
                    var datX = item.dataset.selectValue;
                    if (datX)
                        optionsArray.push(datX);
                });
                urlArray.push({
                    "key": name,
                    "value": optionsArray
                });
            }
        });
        ranges.forEach(function (range) {
            var name = range.getAttribute("name");
            if (range.value !== "0") {
                urlArray.push({
                    "key": name,
                    "value": range.value
                });
            }
        });
        urlArray.forEach(function (entry) {
            urlParams.set(entry.key, entry.value);
        });
        return urlParams;
    },
    renderMobileFilterButton: function () {
        var filtersContainer = document.querySelector("[js-filters]");
        var target = document.querySelector("main");
        var mobileButtonWrapperNode = document.createElement("div");
        var mobileButtonLabel = "";
        mobileButtonWrapperNode.classList.add("filter-mobile");
        mobileButtonWrapperNode.id = "filter-mobile";
        mobileButtonWrapperNode.setAttribute("js-mobile-filter", "");
        target.insertAdjacentElement("beforeend", mobileButtonWrapperNode);
        var targetElement = document.getElementById("filter-mobile");
        if (filtersContainer) {
            var txt = filtersContainer.dataset.labelFilterMobile;
            if (txt !== undefined) {
                mobileButtonLabel = txt;
            }
            else {
                mobileButtonLabel = "Filter";
            }
        }
        if (targetElement) {
            targetElement.style.opacity = '0';
            targetElement.innerHTML = (0, FilterMobile_hbs_1.default)({ "label": mobileButtonLabel });
            window.addEventListener("scroll", function () {
                targetElement.style.opacity = window.scrollY > 10 ? "1" : "0";
            });
        }
    },
    customFilterToogle: function () {
        var customFilters = document.querySelectorAll(".filter-custom .filter-header");
        customFilters.forEach(function (customFilter) {
            if (customFilter) {
                customFilter.addEventListener("click", function (e) {
                    var filterCustomElement = e.target.closest(".filter-custom");
                    if (filterCustomElement) {
                        filterCustomElement.classList.toggle("active");
                    }
                });
            }
        });
    },
    addEventListeners: function () {
        var mobileFilterButton = document.getElementById("filter-mobile");
        var filtersContainer = document.querySelector(".filters");
        var mainContainer = document.getElementById("main-content");
        var mobileMinimizeFilters = document.getElementById("filters-collapse-mobile");
        var selectLists = document.querySelectorAll("[js-select]");
        var ranges = document.querySelectorAll("[js-range]");
        var filterClearAll = document.getElementById("filter-clear");
        var filterClearAllMobile = document.getElementById("filter-clear-mobile");
        if (mobileFilterButton && filtersContainer && mainContainer) {
            mobileFilterButton.addEventListener("click", function () {
                filtersContainer.classList.add("active");
                mainContainer.classList.add("disabled");
            });
        }
        if (mobileMinimizeFilters && filtersContainer && mainContainer) {
            mobileMinimizeFilters.addEventListener("click", function () {
                filtersContainer.classList.remove("active");
                mainContainer.classList.remove("disabled");
            });
        }
        if (filtersContainer && mainContainer) {
            mainContainer.addEventListener("click", function (e) {
                var target = e.target;
                if (target) {
                    if (target.classList.contains("disabled")) {
                        mainContainer.classList.remove("disabled");
                        filtersContainer.classList.remove("active");
                    }
                }
            });
        }
        if (filterClearAll) {
            filterClearAll.addEventListener("click", function (e) {
                var target = e.target;
                var customFilters = document.querySelectorAll(".filter-custom");
                if (target) {
                    if (selectLists.length > 0) {
                        selectLists.forEach(function (selectList) {
                            Select_1.select.clearOptions(selectList);
                        });
                    }
                    if (ranges.length > 0) {
                        ranges.forEach(function (range) {
                            range.value = "0";
                            range.parentNode.querySelector('.range-value').innerHTML = "0 km";
                        });
                    }
                    if (customFilters.length > 0) {
                        customFilters.forEach(function (customFilter) {
                            if (customFilter) {
                                customFilter.classList.remove("active");
                            }
                        });
                    }
                }
            });
        }
        if (filterClearAllMobile) {
            filterClearAllMobile.addEventListener("click", function (e) {
                var target = e.target;
                var customFilters = document.querySelectorAll(".filter-custom");
                if (target) {
                    if (selectLists.length > 0) {
                        selectLists.forEach(function (selectList) {
                            Select_1.select.clearOptions(selectList);
                        });
                    }
                    if (ranges.length > 0) {
                        ranges.forEach(function (range) {
                            range.value = "0";
                            range.parentNode.querySelector('.range-value').innerHTML = "0 km";
                        });
                    }
                    if (customFilters.length > 0) {
                        customFilters.forEach(function (customFilter) {
                            if (customFilter) {
                                customFilter.classList.remove("active");
                            }
                        });
                    }
                }
            });
        }
    },
    filterSearch: function () {
        var searchParams = new URLSearchParams(document.location.search);
        var searchFieldClear = document.querySelector("[js-filter-search-clear]");
        var searchQuery = searchParams.get("q");
        if (searchQuery) {
            if (searchFieldClear) {
                searchFieldClear.style.display = "flex";
            }
        }
        var filterSubmit = document.getElementById("filter-submit");
        var searchFieldInput = document.querySelector("[js-filter-search]");
        var searchFieldButton = document.querySelector("[js-filter-search-button]");
        if (filterSubmit) {
            filterSubmit.addEventListener("click", function (e) {
                e.preventDefault();
                var urlString = filters.set().toString();
                window.location.search = urlString;
            });
        }
        if (searchFieldInput) {
            searchFieldInput.addEventListener("keyup", function (e) {
                if (e.key === 'Enter') {
                    var urlString = filters.set().toString();
                    window.location.search = urlString;
                }
                else {
                    if (e.target) {
                        var input = e.target;
                        if (input.value !== "") {
                            searchFieldClear.style.display = "flex";
                        }
                        else {
                            searchFieldClear.style.display = "none";
                        }
                    }
                }
            });
        }
        if (searchFieldButton) {
            searchFieldButton.addEventListener("click", function () {
                var urlString = filters.set().toString();
                window.location.search = urlString;
            });
        }
        if (searchFieldClear) {
            searchFieldClear.addEventListener("click", function () {
                searchFieldClear.style.display = "none";
                if (searchFieldInput) {
                    searchFieldInput.value = "";
                }
            });
        }
    }
};
exports.filters = filters;
